import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

import MenuItems from './MenuItems';
import Topbar from './Topbar';

import Logo from '../../assets/img/logo/gemasan_logo.svg';
import offCanvasLogo from '../../assets/img/logo/gemasan_logo.svg';

const Header = (props) => {
  const { headerClass, parentMenu, headerLogo, topbarEnable } = props;

  const [menuOpen, setMenuOpen] = useState(false);
  const [offCanvasOpen, setOffCanvasOpen] = useState(false);
  const [isVisible, setIsVisible] = useState(false);
  const [innerWidth, setInnerWidth] = useState(window.innerWidth);

  const [home, setHome] = useState(false);
  const [about, setAbout] = useState(false);
  const [service, setService] = useState(false);
  const [page, setPage] = useState(false);

  const openMobileMenu = (menu) => {
    if (menu === 'home') {
      setHome(!home);
      setAbout(false);
      setService(false);
      setPage(false);
    }
    if (menu === 'about') {
      setHome(false);
      setAbout(!about);
      setService(false);
      setPage(false);
    }
    if (menu === 'service') {
      setHome(false);
      setAbout(false);
      setService(!service);
      setPage(false);
    } else if (menu === 'page') {
      setHome(false);
      setAbout(false);
      setService(false);
      setPage(!page);
    }
  };

  useEffect(() => {
    // Prevent body scroll when offcanvas is open
    if (offCanvasOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
    return () => {
      document.body.style.overflow = '';
    };
  }, [offCanvasOpen]);

  useEffect(() => {
    // Sticky is displayed after scrolling for 100 pixels
    const toggleVisibility = () => {
      if (window.pageYOffset > 100) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };

    window.addEventListener('scroll', toggleVisibility);

    return () => window.removeEventListener('scroll', toggleVisibility);
  }, []);

  useEffect(() => {
    const handleResize = () => {
      setInnerWidth(window.innerWidth);
    };

    window.addEventListener('resize', handleResize);

    return () => window.removeEventListener('resize', handleResize);
  }, []);

  useEffect(() => {
    // Handle mobile menu dropdown toggle
    if (offCanvasOpen && innerWidth < 992) {
      const handleDropdownClick = (e) => {
        const target = e.target.closest('a');
        const parentLi = target?.closest('li.has-dropdown');

        // Check if the clicked link is inside a submenu - if so, let it navigate normally
        const isSubmenuLink = target?.closest('.submenu');
        if (isSubmenuLink) {
          return; // Allow normal navigation for submenu links
        }

        // Only handle dropdown toggle for the parent link
        if (parentLi && target && !target.closest('.submenu')) {
          const parentLink = Array.from(parentLi.children).find(child => child.tagName === 'A');
          if (target === parentLink) {
            e.preventDefault();
            e.stopPropagation();
            const submenu = parentLi.querySelector('.submenu');
            if (submenu && parentLink) {
              const isOpen = submenu.classList.contains('submenu-open');
              if (isOpen) {
                submenu.classList.remove('submenu-open');
                parentLink.classList.remove('active');
              } else {
                submenu.classList.add('submenu-open');
                parentLink.classList.add('active');
              }
            }
          }
        }
      };

      const meanNav = document.querySelector('.mean-nav');
      if (meanNav) {
        meanNav.addEventListener('click', handleDropdownClick);
        return () => {
          meanNav.removeEventListener('click', handleDropdownClick);
        };
      }
    }
  }, [offCanvasOpen, innerWidth]);

  return (
    <>
      {topbarEnable ? <Topbar /> : ''}

      <header>
        <div
          id="header-sticky"
          className={`${headerClass
              ? headerClass
              : 'header__area header__transparent header__space header__plr'
            } ${isVisible ? 'header-sticky' : ''}`}
        >
          <div className="container-fluid">
            <div className="row align-items-center">
              <div className="col-xl-3 col-lg-3 col-7 col-md-6">
                <div className="header__logo">
                  <Link to="/">
                    <img src={headerLogo ? headerLogo : Logo} alt="" />
                  </Link>
                </div>
              </div>
              <div className="col-xl-6 col-lg-7 d-none d-lg-block">
                <div className="header__main-menu text-xxl-end text-center">
                  <nav id="mobile-menu">
                    <ul>
                      <MenuItems parentMenu={parentMenu} />
                    </ul>
                  </nav>
                </div>
              </div>
              <div className="col-xl-3 col-lg-2 col-5 col-md-6">
                <div className="header__action d-flex justify-content-end">
                  <Link
                    className="main-btn-sm d-none d-xl-block tp-btn-hover alt-color"
                    to="/iletisim"
                  >
                    <span>İletişime Geç</span>
                    <b></b>
                  </Link>
                  <div className="header__menu-bar">
                    <button
                      onClick={() => {
                        setOffCanvasOpen(true);
                      }}
                      className={menuOpen ? 'it-menu-bar open' : 'it-menu-bar'}
                    >
                      <i className="far fa-bars"></i>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </header>

      <div className="it-offcanvas-area">
        <div className={offCanvasOpen ? 'itoffcanvas opened' : 'itoffcanvas'}>
          <div className="itoffcanvas__close-btn">
            <button
              onClick={() => {
                setOffCanvasOpen(false);
              }}
              className="close-btn"
            >
              <i className="fal fa-times"></i>
            </button>
          </div>
          <div className="itoffcanvas__logo">
            <Link to="/">
              <img src={offCanvasLogo} alt="" />
            </Link>
          </div>
          <div
            className={
              innerWidth < 992 ? 'mobile-menu mean-container' : 'd-none'
            }
          >
            <div className="mean-bar">
              <nav className="mean-nav">
                <ul>
                  <MenuItems />
                </ul>
              </nav>
            </div>
          </div>
          <div className="itoffcanvas__info">
            <h3 className="offcanva-title">İletişim</h3>
            <div className="it-info-wrapper mb-20 d-flex align-items-center">
              <div className="itoffcanvas__info-icon">
                <a href="#">
                  <i className="fal fa-envelope"></i>
                </a>
              </div>
              <div className="itoffcanvas__info-address">
                <span>E-Posta</span>
                <a href="mailto:info@gemasan.com.tr">info@gemasan.com.tr</a>
              </div>
            </div>
            <div className="it-info-wrapper mb-20 d-flex align-items-center">
              <div className="itoffcanvas__info-icon">
                <a href="#">
                  <i className="fal fa-phone-alt"></i>
                </a>
              </div>
              <div className="itoffcanvas__info-address">
                <span>Telefon</span>
                <a href="tel:+905313008336">0 (531) 300 83 36</a>
              </div>
            </div>
            <div className="it-info-wrapper mb-20 d-flex align-items-center">
              <div className="itoffcanvas__info-icon">
                <a href="#">
                  <i className="fas fa-map-marker-alt"></i>
                </a>
              </div>
              <div className="itoffcanvas__info-address">
                <span>Konum</span>
                <a href="#" style={{ display: 'block', lineHeight: '1.6', color: '#ffffff', textDecoration: 'none', marginTop: '5px' }}>
                  Üniversite Mah. Hastane Cad. No:1913 Ortahisar/Trabzon
                </a>
              </div>
            </div>
          </div>
          <div className="itoffcanvas__social">
            <div className="social-icon">
              <a href="https://www.linkedin.com/company/trgemasan/?viewAsMember=true" target="_blank" rel="noopener noreferrer">
                <i className="fab fa-linkedin-in"></i>
              </a>
              <a href="https://www.instagram.com/trgemasan/" target="_blank" rel="noopener noreferrer">
                <i className="fab fa-instagram"></i>
              </a>
              <a href="https://wa.me/905313008336" target="_blank" rel="noopener noreferrer">
                <i className="fab fa-whatsapp"></i>
              </a>
            </div>
          </div>
        </div>
      </div>

      {offCanvasOpen ? (
        <div
          className="body-overlay apply"
          onClick={() => {
            setOffCanvasOpen(false);
          }}
        ></div>
      ) : (
        <div className="body-overlay"></div>
      )}
    </>
  );
};

export default Header;
